import Dialog from '../Dialog';

const YesNoDialog = ({ isOpen, title, message, onYesClick, onNoClick, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      title={title}
      message={message}
      primaryText="YES"
      onPrimaryClick={onYesClick}
      secondaryText="NO"
      onSecondaryClick={onNoClick}
      onClose={onClose}
    />
  );
};

export default YesNoDialog;
